import { log } from 'log';
import { prop } from 'ramda';
import { useEffect } from 'react';
import { useSocketSelector } from 'js/store/hooks';
import { usePrevious } from 'js/hooks/usePrevious';

import * as constants from '../constants';

export const useOnReconnect = ({
    sdk,
    nextTime,
    triggerGeolocation,
    setTransactionID,
    triggerTimestampRef,
    setLicense,
    setNextTime
}) => {
    const connected = useSocketSelector(prop('connected'));
    const prevConnected = usePrevious(connected);

    useEffect(() => {
        if (connected === prevConnected || !connected) {
            return;
        }

        if (!sdk || !nextTime) {
            return;
        }

        log('gcInfo', { event: 'connectionReconnected' });

        // unset current timeout
        triggerTimestampRef.current = null;
        setTransactionID(null);
        setLicense(null);
        setNextTime(0);

        triggerGeolocation({
            reason: constants.GEOLOCATION_REASON.RECONNECT_CHECK
        });
    }, [
        sdk,
        nextTime,
        connected,
        prevConnected,
        triggerTimestampRef,
        setTransactionID,
        setLicense,
        setNextTime,
        triggerGeolocation
    ]);
};
